/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
jQuery('.product-single--6806520168656 h2.product-single__price-text.js-product-price-text.h3').append('<span id="add_here">/month</span>');
jQuery('.product-single--6806520496336 h2.product-single__price-text.js-product-price-text.h3').append('<span id="add_here">/month</span>');
jQuery( ".account__form-buttons" ).after( "<hr>" );
if (window.location.href.indexOf("collections/all") > -1) {
jQuery('h1.section__title-text.collection__header-info__title-text').text('ALL SOUPS');
jQuery('.template-collection h1.section__title-text.collection__header-info__title-text').text('ALL MEALS');
jQuery('.template-collection nav.breadcrumb span:last-child').text('ALL MEALS');
}
jQuery(".globoRecommendationsBottom").appendTo(".cart__message");
jQuery(".template-product .globoRecommendationsBottom").appendTo(".product-single__bottom .o-layout__item .product-single__content");

jQuery('.secondary-nav__items li').each(function(i) {
 jQuery(this).attr('id','nav_'+i);
});
jQuery('.secondary-nav__items li#nav_0 a').attr('href','https://www.wednesdaysupper.com/account/');
jQuery('#rc_login h5').text('NEED HELP MANAGING YOUR SUBSCRIPTIONS?');